import { Pipe, PipeTransform } from '@angular/core';
import { MediaResponseTime } from '../models/renault-lead-dto';


@Pipe({
    name: 'visitNumber'
})
export class VisitNumberPipe implements PipeTransform {

    transform(value: number, args?: any): any {

        var returnString = "";

        if (value == 0)
            returnString = "0 visitas programadas";

        else if (value > 1)
            returnString = value.toString() +" visitas programadas";

        else
            returnString = value.toString() +" visita programada";

        return returnString;
    }

}
